import type { AppProvisioning } from '@/api/console';

/**
 * EAA-1709: true when a create/update response carries something the operator
 * must see before moving on — a one-time machine-client secret, or a failed
 * Keycloak provisioning step.
 */
export function provisioningNeedsAttention(
    provisioning: AppProvisioning | null | undefined
): boolean {
    if (!provisioning) return false;
    return provisioning.credentials !== null || provisioning.status === 'failed';
}
